import { ReactElement } from 'react';
import compose from 'ia-react-core/~/utils/components/_compose';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow, { WithShowProps } from 'ia-react-core/~/hocs/withShow';
import withFormState from '../../../hocs/form/_withFormState';

import TextControl, { TextControlProps, TextControlValidationProps } from './TextControl';
import withTextControl from './withTextControl';

export * from './TextControl';

const ComposedTextControl: (<
  Value = string,
  StateValue = string,
  V extends Record<string, unknown> = {},
>(props: WithBehaviorsProps<TextControlProps<Value, StateValue> & (keyof V extends never ? {} : V) & TextControlValidationProps & WithShowProps>) => ReactElement<WithBehaviorsProps<TextControlProps<Value, StateValue>>>) = compose<any>(
  withBehaviors,
  withShow,
  withFormState,
  withTextControl,
)(TextControl);

export default ComposedTextControl;
